// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logo_darkLogo__IqQ4X { display: none; }
.Logo_lightLogo__A9sck { display: block; }

/* Manual dark toggle */
[data-theme="dark"] .Logo_darkLogo__IqQ4X  { display: block; }
[data-theme="dark"] .Logo_lightLogo__A9sck { display: none; }

/* System dark preference (when not manually overridden to light) */
@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) .Logo_darkLogo__IqQ4X  { display: block; }
  :root:not([data-theme="light"]) .Logo_lightLogo__A9sck { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Logo/Logo.module.css"],"names":[],"mappings":"AAAA,wBAAY,aAAa,EAAE;AAC3B,yBAAa,cAAc,EAAE;;AAE7B,uBAAuB;AACvB,6CAA0C,cAAc,EAAE;AAC1D,6CAA0C,aAAa,EAAE;;AAEzD,mEAAmE;AACnE;EACE,yDAAsD,cAAc,EAAE;EACtE,yDAAsD,aAAa,EAAE;AACvE","sourcesContent":[".darkLogo { display: none; }\n.lightLogo { display: block; }\n\n/* Manual dark toggle */\n:global([data-theme=\"dark\"]) .darkLogo  { display: block; }\n:global([data-theme=\"dark\"]) .lightLogo { display: none; }\n\n/* System dark preference (when not manually overridden to light) */\n@media (prefers-color-scheme: dark) {\n  :global(:root:not([data-theme=\"light\"])) .darkLogo  { display: block; }\n  :global(:root:not([data-theme=\"light\"])) .lightLogo { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"darkLogo": `Logo_darkLogo__IqQ4X`,
	"lightLogo": `Logo_lightLogo__A9sck`
};
export default ___CSS_LOADER_EXPORT___;
